import {
  CloseIcon,
  createStyles,
  EditIcon,
  IconButton,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  RemoveRedEyeIcon,
  WithStyles,
  withStyles,
} from '@freighthub/silhouette-core'
import cn from 'classnames'
import { observer } from 'mobx-react'
import { Component } from 'react'

import { TNetworkEntity } from '../NetworkEntity'

export interface INetworkListWithActionsItem {
  _id: string
  label: string
  subLabel?: string
  subLabelClassName?: string
  onClickView?: (entity: TNetworkEntity) => void
  onClickDelete?: (_id: string) => void
  onClickEdit?: (entity: TNetworkEntity) => void
  entity?: TNetworkEntity
}

export interface INetworkListWithActionsProps {
  items: INetworkListWithActionsItem[]
}

export class LeanNetworkListWithActions extends Component<INetworkListWithActionsProps> {
  render() {
    return (
      <List>
        {this.props.items.map((item) => (
          <NetworkListWithActionsItem {...item} key={item._id} />
        ))}
      </List>
    )
  }
}

export const NetworkListWithActions = observer(LeanNetworkListWithActions)

const networkListWithActionsItemStyles = () =>
  createStyles({
    text: {
      maxWidth: 450,
      overflow: 'hidden',
      whiteSpace: 'nowrap',
      textOverflow: 'ellipsis',
      display: 'block',
    },
  })

export interface INetworkListWithActionsItemProps
  extends INetworkListWithActionsItem,
    WithStyles<typeof networkListWithActionsItemStyles, false> {}
export class LeanNetworkListWithActionsItem extends Component<INetworkListWithActionsItemProps> {
  render() {
    const { _id, label, subLabel, onClickDelete, onClickEdit, onClickView, entity, classes, subLabelClassName } =
      this.props
    return (
      <ListItem style={{ paddingLeft: 0, paddingRight: 0 }}>
        <ListItemText
          primary={label}
          secondary={subLabel}
          classes={{ primary: classes.text, secondary: cn(classes.text, subLabelClassName) }}
          primaryTypographyProps={{
            title: label,
          }}
          secondaryTypographyProps={{
            title: subLabel,
          }}
        />
        <ListItemSecondaryAction>
          {onClickView && (
            // @ts-expect-error TS(2345) FIXME: Argument of type '({ _id: string | null; organizat... Remove this comment to see the full error message
            <IconButton color="default" onClick={() => onClickView(entity)}>
              <RemoveRedEyeIcon />
            </IconButton>
          )}
          {onClickEdit && (
            // @ts-expect-error TS(2345) FIXME: Argument of type '({ _id: string | null; organizat... Remove this comment to see the full error message
            <IconButton color="default" onClick={() => onClickEdit(entity)}>
              <EditIcon />
            </IconButton>
          )}
          {onClickDelete && (
            <IconButton onClick={() => onClickDelete(_id)}>
              <CloseIcon />
            </IconButton>
          )}
        </ListItemSecondaryAction>
      </ListItem>
    )
  }
}

export const NetworkListWithActionsItem = withStyles(networkListWithActionsItemStyles)(LeanNetworkListWithActionsItem)
